import React, {useContext} from "react";
import {Link} from "react-router-dom";
import LanguageContext from "../context/language";
import {useContent} from "../customHooks/useContent";
import content from '../content/navbar'
import {withRouter} from 'react-router-dom';
import Poland from '../images/Poland.svg';
import UK from '../images/UK.svg';

const Navbar = (props) => {
    const text = useContent(content);

    const {language, changeLanguage} = useContext(LanguageContext);

    const handleClick = () => {
        const newLanguage = language === "en" ? "pl" : "en";
        changeLanguage(newLanguage);
    };

    const addClasses = (path) => {
        const pathname = props.location.pathname;
        const active = path === pathname ? " active" : "";
        return "nav-item" + active;
    };

    const addDropdownClasses = (path) => {
        const pathname = props.location.pathname;
        const active = path === pathname ? " active" : "";
        return "dropdown-item" + active;
    };

    const addToggleClasses = () => {
        const pathname = props.location.pathname;
        const active = pathname.includes('summer-school-iran') ? " active" : "";
        return "nav-link dropdown-toggle" + active;
    };

    return (
        <nav className="navbar navbar-expand-lg">
            <button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarNav"
                    aria-controls="navbarNav" aria-expanded="false"
                    aria-label="Toggle navigation">
                <span className="navbar-toggler-icon oi" data-glyph="menu" title="menu" aria-hidden="true"></span>
            </button>
            <div className="collapse navbar-collapse" id="navbarNav">
                <ul className="navbar-nav">
                    <li className={addClasses('/')}>
                        <Link className="nav-link" to='/'>{text.home}</Link>
                            {/*<span className="sr-only">(current)</span>*/}
                    </li>
                    <li className={addClasses('/people')}>
                        <Link className="nav-link" to='/people'>{text.people}</Link>
                    </li>
                    <li className={addClasses('/projects')}>
                        <Link className="nav-link" to='/projects'>{text.projects}</Link>
                    </li>
                    <li className={addClasses('/resources')}>
                        <Link className="nav-link" to='/resources'>{text.resources}</Link>
                    </li>
                    <li className="nav-item dropdown">
                        <Link className={addToggleClasses()} to="/summer-school-iran/" id="navbarDropdown" role="button"
                           data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                            {text.school}
                        </Link>
                        <div className="dropdown-menu" aria-labelledby="navbarDropdown">
                            <Link className={addDropdownClasses("/summer-school-iran/overview")} to="/summer-school-iran/overview">{text.overview}</Link>
                            <Link className={addDropdownClasses("/summer-school-iran/programme")} to="/summer-school-iran/programme">{text.programme}</Link>
                            <Link className={addDropdownClasses("/summer-school-iran/admission")} to="/summer-school-iran/admission">{text.admission}</Link>
                            <Link className={addDropdownClasses("/summer-school-iran/preparations")} to="/summer-school-iran/preparations">{text.preparations}</Link>
                            <Link className={addDropdownClasses("/summer-school-iran/seasons")} to="/summer-school-iran/seasons">{text.seasons}</Link>
                            <Link className={addDropdownClasses("/summer-school-iran/comments")} to="/summer-school-iran/comments">{text.comments}</Link>
                            <Link className={addDropdownClasses("/summer-school-iran/gallery")} to="/summer-school-iran/gallery">{text.gallery}</Link>
                        </div>
                    </li>
                </ul>
            </div>
            <img alt='Language icon' width="45px" height="30px" src={language === 'en' ? Poland : UK} onClick={handleClick} />
        </nav>
    )
};

export default withRouter(Navbar);
